/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { typeRoadTestAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import * as Data from 'shared/const/data.js'

const TypeRoadTest = ({ t, validateTypeRoadTest, typeRoadTestValid, typeRoadTestError, i18n, setIsError }) => {
  const dispatch = useDispatch()
  const [isHelperOpen, setIsHelperOpen] = useState(false)
  const [isFocussed, SetIsFocussed] = useState(false)

  const typeRoadTest = useSelector((state) => state.driver.driverInformation.typeRoadTest)

  const handleTypeRoadTest = (e) => {
    try {
      let typeRoadTestElem = e.currentTarget.value
      dispatch(typeRoadTestAction(typeRoadTestElem))
      validateTypeRoadTest(Data['roadTestTypes'][typeRoadTestElem][i18n.language])
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    try {
      SetIsFocussed(false)
      validateTypeRoadTest(Data['roadTestTypes'][typeRoadTest][i18n.language])
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          typeRoadTestValid === true
            ? typeRoadTest === ''
              ? ''
              : 'form-group has-success'
            : typeRoadTestValid === false
              ? 'form-group has-error'
              : ''
        }
      >
        <label htmlFor="TypeRoadTestList">{t('driver_information.type_of_road_test')}</label>
        <select
          name="optionlist"
          id="TypeRoadTestList"
          onChange={handleTypeRoadTest}
          value={typeRoadTest}
          onBlur={handleOnBlur}
          onFocus={() => SetIsFocussed(true)}
          className={styles['road_test_type_width']}
        >
          {Object.keys(Data['roadTestTypes']).map((typeRoadTestEach) => {
            return (
              <option value={typeRoadTestEach} key={typeRoadTestEach}>
                {Data['roadTestTypes'][typeRoadTestEach][i18n.language]}
              </option>
            )
          })}
        </select>
        {typeRoadTestValid === true ? (
          typeRoadTest === '' ? (
            ''
          ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
        ) : typeRoadTestValid === false ? (
          <React.Fragment>
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(typeRoadTestError)}</div>
          </React.Fragment>
        ) : (
          ''
        )}
      </div>
      <div className="help-field">
        <i className={['fa fa-exclamation-circle', styles['exclamation_margin_right']].join(' ')} aria-hidden="true"></i>
        <a className="licence_classes_helper_content" onClick={() => setIsHelperOpen(!isHelperOpen)}>
          {t('driver_information.type_of_road_test_helper_heading')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>{' '}
      </div>
      {isHelperOpen ? (
        <div className={styles['helper_content']}>
          <blockquote className={styles['blockquote_font']}>
            <strong>{t('driver_information.type_of_road_test_helper_text_the_type_road_test')}</strong>
            <p>{t('driver_information.type_of_road_test_helper_text_most_people')}</p>
            <ul>
              <li>{t('driver_information.type_of_road_test_helper_text_driving_cars')}</li>
              <li>{t('driver_information.type_of_road_test_helper_text_pickup_trucks')}</li>
              <li>{t('driver_information.type_of_road_test_helper_text_sport_utility')}</li>
              <li>{t('driver_information.type_of_road_test_helper_text_vans_with')}</li>
            </ul>
            <p>
              {t('driver_information.type_of_road_test_helper_text_read_more')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://support.novascotia.ca/services/pay-road-test/#1852'
                    : 'https://support.novascotia.ca/services/pay-road-test-fr/#1852'
                }
              >
                {t('driver_information.type_of_road_test_helper_text_different_types_of')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              .
            </p>
          </blockquote>
        </div>
      ) : null}
    </div>
  )
}

export default withTranslation('common')(TypeRoadTest)
